export default "__VITE_ASSET__BTYqJO9$__"